import { useStore } from "vuex";

export default class GlobalLoadingService {

    private static store: any;

    private static loadingKeyCacheSet = new Set<string>();

    private static getStore() {
        return GlobalLoadingService.store;
    }

    /**
     * 开启Loading遮罩层
     */
    public static openLoading(loadingKey = "defaultKey") {
        this.addLoadingKey(loadingKey);
        const store = GlobalLoadingService.getStore();
        store.commit('openLoading');
    }

    public static OpenTableModal(type = "EMPLOYEE", searchParams = {}) {
        const store = GlobalLoadingService.getStore();
        store.commit('OpenTableModal', {type, searchParams});
    }

    /**
     * 关闭Loading遮罩层， force: 是否强制关闭
     */
    public static closeLoading(loadingKey = "defaultKey", force = false) {
        if(!force){
            const remainCount = this.cleanLoadingKey(loadingKey);
            if (remainCount > 0) {
                return;
            }
        }else{
            // 重置loadingkey缓存，否则会导致其他接口无法正确取消loading效果
            this.loadingKeyCacheSet = new Set<string>();
        }
        const store = GlobalLoadingService.getStore();
        store.dispatch('smoothCloseLoading');
    }

    private static addLoadingKey(loadingKey: string) {
        this.loadingKeyCacheSet.add(loadingKey);
    }

    private static cleanLoadingKey(loadingKey: string) {
        this.loadingKeyCacheSet.delete(loadingKey);
        return this.loadingKeyCacheSet.size;
    }

    static initStore(store: any) {
        this.store = store;
    }
}
